import { CellText } from 'coreOld/elements';

export const columns = [
  {
    accessor: 'number',
    Header: () => <CellText mainText="Part Number" />,
  },
];
